module.exports = __webpack_public_path__ + "img/afternoon_study2_sm.7b2aea71.png";